import { InputMessageThreadSearch } from "@scrile/api-provider/dist/api/MessageThreadsProvider";

export const DEFAULT_SORT: Partial<InputMessageThreadSearch> = {
  sort: "CURRENT_USER_PIN_TIME;HAS_UNREAD_MESSAGES,DESC;UPDATED_TIME,DESC",
};

const messageThreadsSortsItems: Array<{ label: string } & InputMessageThreadSearch> = [
  {
    label: "Unread on top",
    ...DEFAULT_SORT,
    hidden: false,
  },
  {
    label: "Unread only",
    sort: "UPDATED_TIME,ASC",
    unreadOnly: true,
    hidden: false,
  },
  {
    label: "Archive chats",
    sort: "UPDATED_TIME,ASC",
    hidden: true,
  },
];
export const getMessageThreadsSortData = () => {
  const labels: string[] = [];
  const sortItems: Partial<InputMessageThreadSearch[]> = [];
  messageThreadsSortsItems.forEach(el => {
    const { label, ...sortProperties } = el;
    labels.push(label);
    sortItems.push(sortProperties);
  });
  return {
    labels,
    sortItems,
  };
};
